/**
 * Detects if the application is running inside an Evo tab.
 *
 * Possible nesting scenarios:
 *   2-level: Evo (top, cross-origin) → portal iframe
 *   3-level: Evo (top) → msp-admin → portal iframe
 *
 * We first try to access a same-origin-only property on the parent.
 * If the parent is cross-origin (Evo) this throws and we know we are
 * inside Evo.  If the parent is same-origin we fall back to the
 * window.parent !== window.top check for the 3-level case.
 *
 * AB#2231477
 */
export default function isInEvo() {
	if (window.parent === window) return false;
	try {
		void window.parent.document;
		return window.parent !== window.top;
	} catch (e) {
		return true;
	}
}
